import React from "react";

/**
 * PuzzleSectionDivider
 *
 * An interlocking puzzle-piece shaped SVG divider between two page sections.
 * The bottom section "clicks into" the top section like a puzzle tab.
 *
 * Usage: place between two sections, passing the color of the LOWER section
 * (which is what the tab is filled with, since it visually protrudes upward).
 */

export default function PuzzleSectionDivider({
  fill = "#F4F1EA",
  height = 60,
  className = "",
}) {
  // A wide flat line with a puzzle "tab" (bump) in the middle.
  // Viewbox is 100 wide x 12 tall, scaled by container.
  return (
    <div className={`w-full leading-none ${className}`} aria-hidden>
      <svg
        viewBox="0 0 100 12"
        width="100%"
        height={height}
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        <path
          d="M0,12 L0,4 L42,4 C43,4 44,3 44,2 C44,-1 56,-1 56,2 C56,3 57,4 58,4 L100,4 L100,12 Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
